import { on } from "@ngrx/store";
import { ApplicationStore } from "../../../application.state";
import { DataFinancingCompaniesActions } from "./financing-companies.actions";

// **************************************************************************
// FINANCING COMPANIES REDUCER
// **************************************************************************

const load = on(DataFinancingCompaniesActions.load, (state: ApplicationStore) => ({
    ...state,
    data: {
        ...state.data,
        financingCompany: {
            ...state.data.financingCompany,
            financingCompaniesLoading: true,
        },
    },
}));

const loadSuccess = on(DataFinancingCompaniesActions.loadSuccess, (state: ApplicationStore, { financingCompanies }) => ({
    ...state,
    data: {
        ...state.data,
        financingCompany: {
            ...state.data.financingCompany,
            financingCompanies,
            financingCompaniesLoading: false,
        },
    },
}));

const loadFailure = on(DataFinancingCompaniesActions.loadFailure, (state: ApplicationStore, { error }) => ({
    ...state,
    data: {
        ...state.data,
        error,
        financingCompany: {
            ...state.data.financingCompany,
            financingCompaniesLoading: false,
        },
    },
}));

export const financingCompaniesReducer = [load, loadSuccess, loadFailure];
